import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import {FormField} from '@cred/react-form-field'
import {Label} from '@cred/react-label'
import styles from './styles.module.scss'
import {change} from 'redux-form'

// An invalid SSN used to "pre-populate" the input without exposing the users real SSN.
const SECRET_SSN = '#########'

const numberMask = '###-##-####',
  ssnMask = 'xxx-xx-####',
  ssnRegex = /^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/g

/**
 * @deprecated SSN is deprecated, please use @cred/react-basic-form-fields/Ssn or @cred/react-basic-form-fields/[reduxForm|hookForm]/Ssn instead.
 * @visibleName SSN
 */
class SSNEditor extends Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string.isRequired
    }).isRequired,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    withIcon: PropTypes.bool
  }

  static defaultProps = {placeholder: '', withIcon: true}

  constructor(props) {
    super(props)

    const {input: {value: ssn}} = this.props

    if (ssn) {
      if (ssn === SECRET_SSN) {
        this.state = {
          state: '',
          prevSsn: '',
          mask: 'xxx-xx-xxxx'
        }
      } else {
        this.state = {
          ssn: `xxx-xx-${ssn.substring(5)}`,
          prevSsn: `${ssn.substring(0, 3)}-${ssn.substring(3, 5)}-${ssn.substring(5)}`,
          mask: ssnMask
        }
      }
    } else {
      this.state = {
        ssn: '',
        prevSsn: '',
        mask: numberMask
      }
    }
  }

  onChangeSSN = e => {
    const {input: {onChange}} = this.props,
      ssn = e.target.value

    onChange(ssn.replace(/x|-|_/g, ''))
    this.setState({ssn})
  }

  onFocus = () => {
    const {input: {name, value}, meta: {dispatch, form: formName}} = this.props

    if (value === SECRET_SSN) {
      dispatch(change(formName, name, ''))
      this.setState({ssn: '', mask: numberMask})
    } else {
      this.setState(prevState => ({ssn: prevState.prevSsn, mask: numberMask}))
    }
  }

  onBlur = () => {
    const {input: {onBlur}} = this.props

    this.setState(prevState => ({
      ssn: prevState.ssn.match(ssnRegex)
        ? `xxx-xx-${prevState.ssn.substring(7)}`
        : prevState.ssn,
      prevSsn: prevState.ssn,
      mask: ssnMask
    }))

    onBlur()
  }

  render() {
    const {
        placeholder,
        meta,
        input,
        id,
        label,
        withIcon,
        analyticsOptions,
        analyticsContexts,
        overwriteContexts,
        disabledField,
        exposeValue,
        ...props
      } = this.props,
      {mask, ssn} = this.state

    return (
      <FormField status={meta} error={meta.error} disabledField={disabledField} value={input.value} label={label}>
        <NumberFormat
          mask="_"
          format={mask}
          placeholder={placeholder}
          value={ssn}
          disabled={disabledField}
          className="inspectletIgnore"
          onChange={this.onChangeSSN}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          allowEmptyFormatting={input.value === SECRET_SSN}
          {...props}
        />
        {withIcon &&
          <div className={styles.securityCheckSign}>
            <i className="cred-icon icon-security-check"/>
          </div>
        }
        <Label htmlFor={id || input.name}>{label}</Label>
      </FormField>
    )
  }
}

export {SSNEditor}
export default SSNEditor
